import React, { createContext, useContext, useState, ReactNode } from 'react';
import BookDemoFlow from '../../Components/V3/Contact-Modal/BookDemoFlow';
import { trackCta, HeroView } from '../analytics';

interface OpenBookDemoOptions {
	cta_label: string;
	location: string;
	/** Set when fired from the hero, so the event records which hero view was showing. */
	hero_view?: HeroView;
	/** Named PostHog event to fire on open. Defaults to 'demo requested'. */
	event?: string;
}

interface BookDemoContextProps {
	openBookDemo: (options: OpenBookDemoOptions) => void;
}

interface BookDemoProviderProps {
	children: ReactNode;
}

const BookDemoContext = createContext<BookDemoContextProps | undefined>(undefined);

export const BookDemoProvider = ({ children }: BookDemoProviderProps) => {
	const [open, setOpen] = useState(false);

	const openBookDemo = ({ cta_label, location, hero_view, event = 'demo requested' }:OpenBookDemoOptions) => {
		// Product isn't known yet at this point — the visitor picks it inside the modal.
		trackCta(event, { cta_label, product: 'general', location, ...(hero_view && { hero_view }) });
		setOpen(true);
	};
	const closeBookDemo = () => setOpen(false);

	return (
		<BookDemoContext.Provider value={{ openBookDemo }}>
			{children}
			<BookDemoFlow open={open} onClose={closeBookDemo} />
		</BookDemoContext.Provider>
	);
};

export const useBookDemo = () => {
	const context = useContext(BookDemoContext);
	if (!context) {
		throw new Error('useBookDemo must be used within a BookDemoProvider');
	}
	return context;
};
